<template>
  <div>
    <button
      @click="nextStep"
      class="mk-continue"
      v-if="stepActive !== 2|| finish"
    >
      {{$t('visualization.continue')}}
    </button>
  </div>
</template>

<script>
/**
 * Continue Button
 * @author David <david.prenninger@gmx.de>
 *
 * This component shows the main continue button.
 * This button is only present on some pages.
 */
export default {
  computed: {
    stepActive() {
      return this.$store.getters.stepActive;
    },
    finish() {
      return this.$store.getters.finish;
    },
  },
  methods: {
    nextStep() {
      this.$store.dispatch('nextStep');
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/defaults.scss";

.mk-continue {
  position: absolute;
  top: 20px;
  right: 20px;
  border-radius: $br_md;
  background-color: $c_white;
  color: $c_accent;
  padding: 10px 20px;
  border: none;
  box-shadow: $bs_md;
  text-transform: uppercase;

  &:not(.toggle) {
    background-color: $c_white;
  }
}
</style>
